
import Vue from 'vue'
import Samples from './Samples.vue'

import MomentToMomentRatings from './stories/MomentToMomentRatings.story.vue'
import ActivityInterrupts from './stories/ActivityInterrupts.story.vue'
import Player from './stories/Player.story.vue'
import TaggedRatingControl from './stories/TaggedRatingControl.story.vue'
import TimeAdjustmentControl from './stories/TimeAdjustmentControl.story.vue'
import VideoTaggingView from './stories/VideoTaggingView.story.vue'

export default Vue.extend({
  props: {
    API_HOST: String,
  },

  components: {
    Samples,
    Story: MomentToMomentRatings,
  },
})
